import {PlatformProfile} from "../model/platformprofile";
import {User} from "../model/user";
import {Pricing} from "../model/platform/pricing";

export class PlatformUtils {

  public static getCurrentMultiUserPlatformProfileFromSession(): PlatformProfile | undefined {
    const userPlatformMappingFromSessionStorage = sessionStorage.getItem("user_platform_mapping");
    const currentMultiUserFromSessionStorage = sessionStorage.getItem("currentMultiUser");


    if(!userPlatformMappingFromSessionStorage || !currentMultiUserFromSessionStorage) {
      console.error("No user platform mapping or current multi user found in session storage");
      return undefined;
    }

    const currentMultiUser: User = JSON.parse(currentMultiUserFromSessionStorage);
    const userPlatformMapping: Map<string, PlatformProfile> = new Map(JSON.parse(userPlatformMappingFromSessionStorage));
    return userPlatformMapping.get(currentMultiUser.id);
  }

  public static getPlatformPricing(): Pricing | undefined{
    const platformProfile = this.getCurrentMultiUserPlatformProfileFromSession();
    if(platformProfile){
      return platformProfile.pricing;
    }
    return undefined;
  }

}
